import { EditCtrl } from "../../Editor/index"

export default class TypPolozkyCennikaEditCtrl extends EditCtrl {

  static $inject = ["item", "saveHandler", "$rootScope"];

  constructor(item, saveHandler, $rootScope){
    super(item, saveHandler);
    this.$rootScope = $rootScope;
  }

  submit() {
    this.form.$setSubmitted();

    console.log(this.form);

    if (this.form.$valid) {
      let dto = {};
      if (this.item.id === 0)
        dto.cennik = this.item.cennik;

      for (let key of ['kod', 'jednotka', 'nazov', 'popis', 'poznamka', 'EENN', 'EEVN', 'PLYNMO', 'PLYNVOSO', 'dan'])
        if (this.form[key].$dirty)
          dto[key] = this.item[key];

      this.saveHandler(this.item.id, dto).then(() => {
        this.$rootScope.back();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/Cennik/TypPolozkyCennika/TypPolozkyCennikaEditCtrl.js